import { useMemo } from 'react'

import { MtTypography } from '@makyoapp/makyo-tw-ui'

import { CustomFontsRecord } from '@/shared/builder/types'
import { getGoogleFontLink } from '@/shared/gapi'

function collectFonts(typograhyConfig: MtTypography) {
  const list: CustomFontsRecord = {}
  if (typograhyConfig) {
    for (const k of Object.keys(typograhyConfig)) {
      const bt = typograhyConfig[k as keyof MtTypography]
      const fn = bt.familyName
      const style = bt.familyStyle
      if (!list[fn]) {
        list[fn] = {
          [style]: style,
        }
      } else if (!list[fn][style]) {
        list[fn][style] = style
      }
    }
  }
  return list
}

/**
 * Custom hook to genrate google font link from:
 * - brandkit typography fonts
 * - app builder custom fonts
 */
export function useFontLink(typograhyConfig: MtTypography, customFonts: CustomFontsRecord = {}) {
  // generate fonts from the brandkit
  const fonts = useMemo(() => collectFonts(typograhyConfig), [typograhyConfig])
  const hasFont = Object.keys(fonts).length > 0
  const fontLink = hasFont ? getGoogleFontLink(fonts) : null

  // generate custom fonts
  const hasCustomFontLink = Object.keys(customFonts).length > 0
  const customFontLink = hasCustomFontLink ? getGoogleFontLink(customFonts) : null

  return {
    fontLink,
    customFontLink,
  }
}
